import { useState } from "react";
import { toast } from "sonner";
import { EFF_LARGE } from "../../lib/effLargeWordlist";

function generateSix(): string {
  const buf = new Uint32Array(6);
  crypto.getRandomValues(buf);
  return Array.from(buf)
    .map((n) => EFF_LARGE[n % EFF_LARGE.length])
    .join(" ");
}

export function PassphraseGenerator({
  onChoose,
}: {
  onChoose: (passphrase: string) => void;
}) {
  const [phrase, setPhrase] = useState(() => generateSix());
  return (
    <div className="mt-3 rounded-lg border border-accent-soft/20 bg-accent-bg/40 p-3">
      <div className="mb-2 flex items-center justify-between text-xs">
        <span className="text-accent-soft">
          ✨ generator · six-word EFF large list
        </span>
        <div className="flex gap-3 text-text-soft">
          <button
            type="button"
            onClick={() => {
              const next = generateSix();
              setPhrase(next);
            }}
            className="hover:text-text"
          >
            ↻ shuffle
          </button>
          <button
            type="button"
            onClick={() => {
              void navigator.clipboard.writeText(phrase).then(() => {
                toast.success("Copied — auto-clearing in 30s");
                setTimeout(() => {
                  void navigator.clipboard.writeText("");
                }, 30_000);
              });
            }}
            className="hover:text-text"
          >
            copy
          </button>
          <button
            type="button"
            onClick={() => onChoose(phrase)}
            className="text-accent-soft hover:text-text"
          >
            use this
          </button>
        </div>
      </div>
      <div className="font-mono text-sm tracking-wide">{phrase}</div>
    </div>
  );
}
